import { Avatar, Box, Flex, Text } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import { AnimateKeyframes } from 'react-simple-animate';

import { useStores } from '../hooks/useStores';
import { UserRoles } from '../types/shared';
import TrackProgressBar from './TrackProgressBar';
import VibylDiscCover from './VinylDiscCover';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        currentTrack: store.playback.currentTrack,
        isPlaying: store.playback.config.isPlaying,
        currentTrackColors: store.config.currentTrackColors,
        isHost: store.auth.role === UserRoles.HOST,
    }));
}

const CurrentTrack = () => {
    const { currentTrack, isPlaying, currentTrackColors, isHost } = useStoreData();

    return (
        <Flex
            flex={1}
            justifyContent={['center']}
            p={['0 1rem', '.5rem 1rem']}
            maxWidth="600px"
            w="100%"
            direction="column"
            alignItems="center"
        >
            <Box maxWidth={['90%', '95%', '600px']} w="100%" p={['.5rem', '1rem', '1rem']} position="relative">
                <AnimateKeyframes
                    play
                    duration={0.3}
                    direction="normal"
                    keyframes={[
                        { 0: 'opacity: 0' },
                        { 0: 'transform: translate(30%)' },
                        { 100: 'opacity: 1' },
                        { 100: 'transform: translate(0%)' },
                    ]}
                >
                    <VibylDiscCover isPlaying={isPlaying} currentTrack={currentTrack} />
                    {isHost && <TrackProgressBar />}
                </AnimateKeyframes>
            </Box>
            <Flex mt="1rem" minH={['84px', '84px', '108px']} direction={['column']} justifyContent="space-between" w="100%">
                {currentTrack && (
                    <>
                        <Flex flex={1} justifyContent={['center']} alignItems="center" opacity={0.6}>
                            <Text m="0" fontSize={['.8rem', '1rem']} lineHeight={['.8rem', '1rem']}>
                                by {currentTrack.user ? currentTrack.user.displayName : 'onplaylist.io'}
                            </Text>
                            <Avatar
                                display={['none', 'block']}
                                ml="1rem"
                                size="md"
                                name={currentTrack.user ? currentTrack.user.displayName : 'one playlist'}
                                src={currentTrack.user ? currentTrack.user.photoURL : undefined}
                            ></Avatar>
                        </Flex>
                        <Flex alignItems={['center']} direction="column" flex={2}>
                            <Text
                                textAlign={['center']}
                                fontSize={['1.3rem']}
                                m={['.5rem 0']}
                                p={['0 2rem']}
                                lineHeight={['1.5rem']}
                                opacity={0.8}
                            >
                                {currentTrack.track.name}
                            </Text>
                            <Text m="0" fontSize={['1rem']} lineHeight={['1.3rem']} color={currentTrackColors[1]}>
                                {currentTrack.track.artists}
                            </Text>
                        </Flex>
                    </>
                )}
            </Flex>
        </Flex>
    );
};

export default CurrentTrack;
